import React, { useEffect, useState } from 'react';
// @ts-ignore
import { useHistory } from 'react-router';
import qs from 'qs';
import config from 'react-global-configuration';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Button, PatternBlock } from '../../../components';
import type { NLdoetBlockCTA } from '../../../types/uncinc_profile/blocks';

import { LocationSearch } from '../../../components/Search/NLdoet/ProjectSearch/Filters/Search';
import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

export interface NLdoetCallToActionBlockProps {
  entity: ImmutableEntity<NLdoetBlockCTA>;
}

const NLdoetCallToActionBlock: React.FC<NLdoetCallToActionBlockProps> = ({ entity }) => {
  const [count, setCount] = useState('0');
  const history = useHistory();
  const block = entity.toJS();

  const title = block.info[0]?.value;
  const body = block.body[0]?.processed || '';
  const searchActive = block.field_search_active?.[0]?.value || false;

  const link = block.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = block.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  const API_URL = config.get('API_URL');

  const getProjectCount = () => {
    const url = `${API_URL}/api/nldoet_project_count?_format=json`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setCount(response[0].nid);
      }).catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getProjectCount();
  }, []);

  return (
    <Container>
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className="NLdoetCTABlock">
            <PatternBlock className="NLdoetCTABlock__pattern">

              <div className="NLdoetCTABlock__title">
                <h3>{title.replace('[count]', count)} </h3>
              </div>
              <div className="NLdoetCTABlock__subtitle">
                {body && (
                  <WysiwygField
                    property="schema:text"
                    html={body}
                  />
                )}
              </div>
              <div className="NLdoetCTABlock__actions">
                {searchActive && (
                  <LocationSearch
                    labelKey="nldoet.homepage.search.placeholder"
                    onChange={(obj: any) => {
                      const filters = [
                        { identifier: 'area_name', value: obj.name },
                        {
                          identifier: 'fake_box',
                          geoBoundingBox: {
                            topLeft: { lat: obj.bounds.NE.lat, lon: obj.bounds.SW.long },
                            bottomRight: { lat: obj.bounds.SW.lat, lon: obj.bounds.NE.long },
                          },
                        },
                      ];
                      const queryString = qs.stringify({ filters }, { encode: true });
                      // @ts-expect-error
                      const url = `/${APP_OPTIONS?.parameters?.nldoetProjectMapUrl}?${queryString}`;
                      history.push(url);
                    }}
                  />
                )}
                {linkTitle && (
                  <div className="NLdoetCTABlock__actions__button">
                    <Button
                      withIcon
                      buttonIcon={!searchActive}
                      secondary
                      href={searchActive ? 'internal:/zoeken' : linkUrl}
                      className="NLdoetCTABlock__actions__button__button"
                    >
                      {linkTitle}
                    </Button>
                  </div>
                )}
              </div>
              {secondaryLinkTitle && (
                <div className="NLdoetCTABlock__link">
                  <CoreLink href={secondaryLinkUrl}>
                    {secondaryLinkTitle}
                    <div className="icon icon-arrow-right icon-variant-4" />
                  </CoreLink>
                </div>
              )}
            </PatternBlock>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NLdoetCallToActionBlock;
